export const useIsPaymentsLegacyUser = (): boolean => {
  return false;
};
